export default class Navbar {
    static init(): void {
        if (window.innerWidth > 768) {
            const navbarCollapse = document.querySelector('.navbar-collapse');

            if (navbarCollapse) {
                const dropdowns = navbarCollapse.querySelectorAll('.dropdown');

                if (dropdowns.length > 0) {
                    dropdowns.forEach((dropdown) => {
                        const menu = dropdown.querySelector('.dropdown-menu');
                        if (menu) {
                            dropdown.addEventListener('mouseover', () => {
                                menu.classList.add('show');
                            })
                        }
                    });
                    dropdowns.forEach((dropdown) => {
                        const menu = dropdown.querySelector('.dropdown-menu');
                        if (menu) {
                            dropdown.addEventListener('mouseleave', () => {
                                menu.classList.remove('show');
                            })
                        }
                    });
                }
            }
        }
    }
}
